module.exports = __webpack_public_path__ + "static/media/bg-login.433979b7.jpg";